const dateUtil = {
    addDays: (date, days) => {
    },
    addDaysToLocalDate: (localDate, daysToAdd) => {
        if(localDate && daysToAdd){
            const dateObj = dateUtil.toDate(localDate).getDate() + daysToAdd;
            return dateUtil.toLocalDate((new Date(new Date().setDate(dateObj))));
        }
        return localDate
        
    },
    getDifferenceBetweenDates: (startDate, endDate) => {
        const diffTime = Math.abs(startDate - endDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        return diffDays
    },
    getDifferenceBetweenLocalDates: (startDate, endDate) => {
        const _endDate = new Date(endDate.year, endDate.month, endDate.day);
        const diffTime = Math.abs(startDate - _endDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        return diffDays;
    },
    toDate: (localDate) => {
        return new Date(localDate.year, localDate.month, localDate.day)
    },
    toLocalDate: (dateObj) => {
        return {
            year: dateObj.getFullYear(), 
            month: dateObj.getMonth(), 
            day: dateObj.getDate()
        }
    },
    getAge: (dateObj) => {
        const dateOfBirth = dateUtil.toDate(dateObj)
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        var age = today.getUTCFullYear() - dateOfBirth.getUTCFullYear();
        var thisYearsBirthDate = new Date(today.getUTCFullYear(), dateObj.month, dateObj.day);
        if (thisYearsBirthDate > today) {
          age--;
        }
        return age;
    }
}

const PortalUtil = {
    dateUtil
}

export default PortalUtil
